import React, { useLayoutEffect, useMemo, useRef, useState } from "react";
import { checkIfObject } from "../../../../libraries/_helpers";
import useResize from "../../hooks/useResize";
import { trackFilterClick } from '../../../../libraries/_modules/tracking/helpers';
import { translateTypes } from "../../utils";
import { useReactAppState } from "../../containers/utils";

function findOption({ items, value, valueKey }) {
  if (!value || !items || items.length === 0) {
    return;
  }

  const matchedOption = (items || []).find((item) => {
    if ((valueKey && item[valueKey] && item[valueKey].toString() === value?.toString()) || item?.toString() === value?.toString()) {
      return item;
    }
  });

  return matchedOption ? matchedOption : items[0];
}

const trackClick = (statsCategory, filterType, clickItem) => {
  trackFilterClick({ statsCategory, filterType, clickItem });
};

const Dropdown = ({ extraClass, onChangeFn, items, type, currentValue, valueKey, displayKey, autoWidth = true, disabled = false, ariaLabel = "", title = "" }) => {
  const optionFound = useMemo(() => findOption({ items, value: currentValue, valueKey }), [items, currentValue, valueKey]);

  const ref = useRef(null);
  const { t } = useReactAppState() || {};

  function handleResize() {
    if (ref?.current && autoWidth) {
      setWidth(ref.current.offsetWidth + 48);
    }
  }

  const [width, setWidth] = useState("auto");
  const [selectedOption, setSelectedOption] = useState(optionFound);

  useLayoutEffect(() => {
    setSelectedOption(optionFound);
  }, [items, currentValue]);

  useLayoutEffect(() => {
    handleResize();
  }, [items, selectedOption]);

  useResize(handleResize, 1000);

  const handleChange = React.useCallback((e) => {
    onChangeFn(e.target.value);
    trackClick('schedule', type, e.target.options[e.target.selectedIndex].innerText);
  }, [onChangeFn], []);

  return (
    <>
      <select
        onChange={handleChange}
        value={currentValue}
        style={{ width }}
        aria-label={ariaLabel}
        title={title}
        className={`mls-o-buttons__dropdown-button mls-o-buttons__dropdown-button--right ${extraClass ? extraClass : ""}`} disabled={disabled}  >
        {
          items
            ? items.map((item, index) => {
              const isObject = checkIfObject(item);
              return (
                <option
                  className="mls-o-buttons__dropdown-item"
                  value={isObject && valueKey != null
                    ? item[valueKey]
                    : item}
                  key={`${isObject && valueKey != null
                    ? item[valueKey]
                    : isObject
                      ? JSON.stringify(item)
                      : item
                    }${index}`}
                >
                  {isObject ? translateTypes(t, item[displayKey]) : translateTypes(t, item)}
                </option>
              );
            })
            : null
        }
      </select>
      <div className="mls-o-buttons__dropdown-hidden">
        <span ref={ref} style={{ visibility: "hidden" }}>
          {
            displayKey && selectedOption && selectedOption[displayKey]
              ? translateTypes(t, selectedOption[displayKey])
              : translateTypes(t, selectedOption)
          }
        </span>
      </div>
    </>
  );
};

export default Dropdown;
